import { useCallback, useEffect } from 'react';
import { memo } from 'react';
import { Box, List, Skeleton } from '@bonanza-social/moonlight';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { FreeSpin } from '../../services/RewardsService.schemas';
import { ListRenderItem } from 'react-native';
import FreeSpinsGame from './FreeSpinsGame';
import {
  fetchFreeSpins,
  selectFreeSpins,
  selectFreeSpinsDataState,
} from '../../state/rewards.slice';
import FreeSpinsEmpty from './FreeSpinsEmpty';
import RewardsSection from '../RewardsSection/RewardsSection';

function FreeSpinsSection() {
  const dispatch = useDispatch();
  const freeSpinsDataState = useSelector(selectFreeSpinsDataState);
  const freeSpins = useSelector(selectFreeSpins);

  useEffect(() => {
    dispatch(fetchFreeSpins());
  }, [dispatch]);

  const renderSeparator = useCallback(() => <Box width="space-400" />, []);

  const renderItem = useCallback<ListRenderItem<FreeSpin>>(({ item }) => {
    return (
      <>
        {item.games.map((game) => (
          <FreeSpinsGame
            id={game.id}
            spinsLeft={item.freeSpinsLeft}
            key={game.id}
          />
        ))}
      </>
    );
  }, []);

  if (freeSpinsDataState.match('idle|pending')) {
    return <Skeleton height={175} />;
  }

  return (
    <RewardsSection titleLocKey="rewards">
      <List
        data={freeSpins}
        renderItem={renderItem}
        showsHorizontalScrollIndicator={false}
        horizontal
        ItemSeparatorComponent={renderSeparator}
        ListEmptyComponent={<FreeSpinsEmpty />}
        contentContainerStyle={{ flex: 1 }}
      />
    </RewardsSection>
  );
}

export default memo(FreeSpinsSection);
